import { Box, Container } from '@chakra-ui/react';

const Loginpage = () => (
  <Container>
    <Box py="6">Login</Box>
  </Container>
);

export default Loginpage;
